<template>
    <div class="modal hide fade in" id="modalEnvio" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title label-black">Datos para el Envío</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div id="SeleccionMovimiento">
                <div class="row">
                        <div class="form-group col-4">
                            <label class="label-black">Fecha de Movimiento</label>
                            <input type="date" id="fechaDeEnvio_div" class="form-control" v-model="FechaCalendario"/>
                        </div>
                        <div class="form-group col-2">
                        </div>
                        <div class="form-group form-check col-6 align-self-center" v-if="adminEnvio==true">
                            <input type="checkbox" id="checkExterno_id" class="form-check-input" v-model="Externo"/>
                            <label class="label-black">Movimiento Area Externa</label>
                        </div>
                </div>

            </div>    
            <div id="EnvioInterno" v-if="this.Externo==false">     
                    <div class="row">
                        <div v-if="this.adminEnvio != false" class="form-group col-6" id="AreaReceptorSelect_div">
                            <label class="label-black">Área Receptora</label>
                            <CAreas
                            v-on:valorParaElPadre="cambioDeAreaReceptora" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'filtroDeBusqueda_AreaReceptora'" 
                            :parametros="parametros_AreaReceptora" 
                            :valorDefinido="parametros_AreaReceptora.areaId" 
                            :key="parametros_AreaReceptora.areaId"
                            >
                            </CAreas>
                        </div>
                        <div v-else class="form-group col-6" id="AreaReceptorInput_div">
                            <label class="label-black">Área Receptora</label>
                            <input type="text" class="form-control" v-model="AreaConsulta.Nombre" readonly/>
                        </div>
                        <div class="form-group col-6" id= "UsuarioReceptor_div" v-if="parametros_AreaReceptora.areaId!=20 && parametros_AreaReceptora.areaId!=21 && parametros_AreaReceptora.areaId>0">
                            <label class="label-black">Usuario Receptor</label>
                            <CCuentas
                            v-on:valorParaElPadre="cambioDeUsuarioReceptor" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'filtroDeBusqueda_UsuarioReceptor'" 
                            :parametros="{}" 
                            :valorDefinido="parametros_UsuarioReceptor.usuarioId" 
                            
                            :areaConsultaId="parametros_AreaReceptora.areaId"
                            >
                            </CCuentas>
                        </div>
                        
                            <div class="form-group col-6" id="ReceptorEjecutoresInput_div" v-else-if="parametros_AreaReceptora.areaId!=21">
                                <label class="label-black">Usuario Dirección de Ejecutores</label>
                                <input type="text" class="form-control" v-model="UsuarioEjecutores"/>
                            </div>
                        
                    </div>
                    <div class="row" v-if="parametros_AreaReceptora.areaId!=20 && parametros_AreaReceptora.areaId!=21 && parametros_AreaReceptora.areaId==AreaConsulta.AreaId">
                        <div class="form-group form-check col-12 text-right" v-if="adminEnvio==true">
                            <input type="checkbox" id="checkExterno_id" class="form-check-input" v-model="boolRecepcionAutomatica"/>
                            <label class="label-black">Generar Recepción Automatica</label>
                        </div>
                    </div>
            </div>
            <div id="Envio_Externo" v-else>
                <div class="row">
                    <div class="form-group col-4" id="AreaExternoInput_div">
                        <label class="label-black">Área Externa</label>
                        <CExterno
                            v-on:valorParaElPadre="cambioDeAreaExterna" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'filtroDeBusqueda_AreaExternoInput'" 
                            :parametros="parametros_Externo" 
                            :valorDefinido="parametros_Externo.areaExternaId" 
                            >
                        </CExterno>
                    </div>
                    <div class="form-group col-8" id="ReceptorExternoInput_div">
                        <label class="label-black">Usuario Receptor</label>
                        <input type="text" class="form-control" v-model="datosExternos.NombreReceptor"/>
                    </div>
                </div>
                <div class="row" v-if="parametros_Externo.areaExternaId>0">
                    <div class="form-group col-4" id="ReceptorExternoInput_div">
                        <label class="label-black">{{parametros_Externo.Nombre}} No:</label>
                        <input type="number" class="form-control" v-model="datosExternos.Numero"/>
                    </div>
                    <div class="form-group col-8" id="ReceptorExternoInput_div">
                        <label class="label-black">Observaciones</label>
                        <input type="text" class="form-control" v-model="datosExternos.Observaciones"/>
                    </div>
                </div>
            </div>
            <div class="row" v-if="parametros_Externo.areaExternaId<0">
                <div class="form-group col-12">
                    <label class="label-black">Observaciones</label>
                    <textarea type="text" v-model ="ObservacionesParaEnvio" rows ="3" class="form-control" placeholder="Escriba alguna observación sobre envió del documento" />
                </div>
            </div>
          
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-sm" id="botonCancelar" >Cancelar</button>
          <button type="button" class="btn btn-custom btn-sm" id="botonAceptar" >Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import LogoPJE from '@/../src/assets/Logotipo_Positivo_Vertical-recibo.png'


export default {
    components: {
        CAreas : catalogos.ArchivoJudicial.C001Areas,
        CCuentas: catalogos.Cuentas.C001Usuario,
        CExterno : catalogos.ArchivoJudicial.C016AreasExternas,
    },
    props: {
        adminEnvio: {
            type: Boolean,
            default: false
        },
        ListadoParaEnvio: {
            type: Array,
            default : null
        },
        TotalVolumenes: 0,
        usrArea: Object,
        JuicioDatos: Object
    },
    data(){
        return{
            enumeraciones,
            conSolicitudes: 0,
            fueraArea: 0,
            parametros_AreaReceptora: {
                areaId: -1,
                Nombre: "",
                conMaterias: true
            },
            parametros_UsuarioReceptor:{
                usuarioId: -1
            },
            parametros_Externo:{
                areaExternaId: -1,
                Nombre: ""
            },
            FechaCalendario: moment().format('YYYY-MM-DD'),
            ObservacionesParaEnvio: "",
            ListaQueSeVa: [],
            AreaConsulta : {
                AreaId:0,
                Nombre: ""
            },
            Actual: 0,
            Externo: false,
            UsuarioExterno: "",
            UsuarioEjecutores: "",
            areaEjecutor: false,
            usuarioQueGenera: {
                Nombre: "",
                ApellidoPaterno:"",
                ApellidoMaterno: "",
                AreaAsignado: {
                    AreaId: 0,
                    Nombre: ""
                }
            },
            datosDelJuicio:{},
            EditTable : false,
            boolArchivo: false,
            boolRecepcionAutomatica: false,
            fechaParaRecepcion: '',
            datosExternos: {
                NombreReceptor: "",
                Numero: null,
                Observaciones : ""
            }
        }
    },
    methods: {
        Mostrar: function () {
        $('#modalEnvio').modal('show');
        $('#botonCancelar').unbind('click').click(this.CerrarModal);
        $('#closeModal').unbind('click').click(this.CerrarModal);
        $('#botonAceptar').unbind('click').click(this.EnviarDocumento);
        },
        ModalClose: function(dato){
            $('#modalEnvio').modal('hide');
            this.$emit('dialogo', {"Cerrado": false, "Enviado": dato});
        },
        CerrarModal(dato){
            this.ModalClose(dato!=true? false: true);
        },
        cambioDeAreaReceptora(datos){
            this.parametros_AreaReceptora.areaId = parseInt(datos[0].target.value);
            if(this.parametros_AreaReceptora.areaId !=21)
            {
                this.parametros_AreaReceptora.Nombre = datos[0].target.selectedOptions[0].text;
                this.parametros_UsuarioReceptor.usuarioId = -1;
                this.boolArchivo =false;
            }
            else
            {
                var mensaje ="Para el envío al Archivo, en caso de prestamo vigente realice los movimientos por Solicitudes Activas, en caso de envío por primera vez, gestione en Listado para envió al Archivo </br></br>";
                    comun.mensajeDeAlerta(mensaje , null, null);
                    this.parametros_AreaReceptora.areaId = this.AreaConsulta.AreaId;
                    this.boolArchivo = true;
                
            }
        },
        cambioDeAreaExterna(datos){
            this.parametros_Externo.areaExternaId = parseInt(datos.target.value);
            this.parametros_Externo.Nombre = datos.target.selectedOptions[0].text;
        },
        cambioDeUsuarioReceptor(datos){
            this.parametros_UsuarioReceptor.usuarioId = parseInt(datos.IdUsuario); //target.value);
        },
        EnviarDocumento: function(){
            let EstatusImpresion = false;
            let Recepcion = this.boolRecepcionAutomatica;
            let rFecha = this.fechaParaRecepcion;
            let Volumenes = [];
            let Incidentes = [];
            let Tercerias = [];
            let Genera = this.usuarioQueGenera;
            if(this.boolArchivo==false)
            {
                $.each(this.ListaQueSeVa, function(index, volumen){
                    
                    if(volumen.VolumenId!=null && volumen.Volumen!=null)    {
                        Volumenes.push({
                            "VolumenId": volumen.Volumen.VolumenId,
                            "Fojas": parseInt(volumen.Volumen.Fojas),
                            "Contenedor": volumen.Volumen.Contenedor,
                            "Area": volumen.Volumen.Area,
                            "EstatusVolumenes": volumen.Volumen.EstatusVolumenes
                        })
                    }
                    if(volumen.IncidenteId!=null)    {
                        Incidentes.push({
                            "IncidenteId": volumen.Incidente.IncidenteId,
                            "Contenedor": volumen.Incidente.Contenedor,
                            "Area": volumen.Incidente.Area,
                            "EstatusVolumenes": volumen.Incidente.EstatusVolumenes
                        })
                    }
                    if(volumen.TerceriaId!=null)    {
                        Tercerias.push({
                            "TerceriaId": volumen.Terceria.TerceriaId,
                            "Contenedor": volumen.Terceria.Contenedor,
                            "Area": volumen.Terceria.Area,
                            "EstatusVolumenes": volumen.Terceria.EstatusVolumenes
                        })
                    }
                        
                });
                if(this.validaDatos()==true)
                {
                var enviarExterno = this.Externo;
                var NombreExterno = this.datosExternos;
                var juicio = this.datosDelJuicio;
                var apiEnvio = "";
                var mov = 0;
                
                
                if(this.adminEnvio)
                {
                    apiEnvio = api.conexion + api.ArchivoJudicial.EnvioArchivo;
                }
                else
                {
                    apiEnvio = api.conexion + api.ArchivoJudicial.EnvioInterno;
                };
                
            
                if(this.AreaConsulta.AreaId == this.parametros_AreaReceptora.areaId)
                {
                        mov = 3; //Interno
                        
                };
                
                if (this.AreaConsulta.AreaId != this.parametros_AreaReceptora.areaId && this.parametros_AreaReceptora.areaId != 21)
                {
                    mov = 5; //Otras Areas diferentes del Archivo
                    
                };
                if (this.AreaConsulta.AreaId != this.parametros_AreaReceptora.areaId && this.parametros_AreaReceptora.areaId == 21)
                {
                    mov = 7; //Prestamos No Registrados
                    
                };
                if(this.Externo == true)
                {
                    mov = 5; //Otras Areas diferentes del Archivo
                };
                    
                var MovimientosDocumentos =[];
                var usuarioRecibe = this.parametros_UsuarioReceptor.usuarioId!=-1?this.parametros_UsuarioReceptor.usuarioId : null;
                var areaRecibe = this.parametros_AreaReceptora.areaId;
                let ObsParaEnvio = this.ObservacionesParaEnvio;
                let fechaDeControl= this.FechaCalendario;
                let Ejecutor = this.UsuarioEjecutores;
                let area_Externa = this.parametros_Externo.areaExternaId;
                var Nombre_Externo = this.parametros_Externo.Nombre;
                var NombreEjecutores = this.parametros_AreaReceptora.Nombre;
                var usrImpresion = {}

                var LlamaApi = false;

                $.each(this.ListaQueSeVa, function(index, movimientos){
                        var FechaEnvio = ""
                        if(fechaDeControl == moment().format('YYYY-MM-DD'))
                        {
                            FechaEnvio = moment().format('YYYY-MM-DD') + ' ' + moment().format('HH:MM');
                        }
                        else{
                            FechaEnvio = fechaDeControl + ' 10:00:00.0';
                            
                        }
                        
                        if(movimientos.UsuarioQuienRecibe.IdUsuario != usuarioRecibe)
                        {
                            
                            if (enviarExterno == false)
                            {
                                if(areaRecibe !=20)
                                {
                                    if(Recepcion==true)
                                    {
                                        MovimientosDocumentos.push({
                                        "VolumenId": movimientos.VolumenId,
                                        "IncidenteId": movimientos.IncidenteId,
                                        "TerceriaId": movimientos.TerceriaId,
                                        "FechaMovimiento": FechaEnvio,
                                        "UsuarioQuienPresta" :{"IdUsuario": movimientos.UsuarioQuienRecibe.IdUsuario},
                                        "UsuarioQuienRecibe" :{"IdUsuario": usuarioRecibe},
                                        "AreaQuePresta": {"AreaId": movimientos.AreaQueRecibe.AreaId},
                                        "AreaQueRecibe": {"AreaId": areaRecibe},
                                        "SolicitudDocumentoId" : movimientos.SolicitudDocumentoId,
                                        "FechaRecepcion": rFecha,
                                        "Observaciones" : ObsParaEnvio }
                                        );
                                    }
                                    else
                                    {
                                        MovimientosDocumentos.push({
                                        "VolumenId": movimientos.VolumenId,
                                        "IncidenteId": movimientos.IncidenteId,
                                        "TerceriaId": movimientos.TerceriaId,
                                        "FechaMovimiento": FechaEnvio,
                                        "UsuarioQuienPresta" :{"IdUsuario": movimientos.UsuarioQuienRecibe.IdUsuario},
                                        "UsuarioQuienRecibe" :{"IdUsuario": usuarioRecibe},
                                        "AreaQuePresta": {"AreaId": movimientos.AreaQueRecibe.AreaId},
                                        "AreaQueRecibe": {"AreaId": areaRecibe},
                                        "SolicitudDocumentoId" : movimientos.SolicitudDocumentoId,
                                        "Observaciones" : ObsParaEnvio }
                                        );
                                    }
                                }
                                else
                                {
                                    //Ejecutores Envio y recepcion
                                    MovimientosDocumentos.push({
                                    "VolumenId": movimientos.VolumenId,
                                    "IncidenteId": movimientos.IncidenteId,
                                    "TerceriaId": movimientos.TerceriaId,
                                    "FechaMovimiento": FechaEnvio,
                                    "UsuarioQuienPresta" :{"IdUsuario": movimientos.UsuarioQuienRecibe.IdUsuario},
                                    "UsuarioQuienRecibe" :{"IdUsuario": null},
                                    "AreaQuePresta": {"AreaId": movimientos.AreaQueRecibe.AreaId},
                                    "AreaQueRecibe": {"AreaId": areaRecibe},
                                    "SolicitudDocumentoId" : movimientos.SolicitudDocumentoId,
                                    "FechaRecepcion": moment().format('YYYY-MM-DD HH:MM'),
                                    "Observaciones" : "Envio a Dirección de Ejecutores, recibido por: "+ Ejecutor +", Con Observaciones: " + ObsParaEnvio }
                                    );
                                    MovimientosDocumentos.push({
                                    "VolumenId": movimientos.VolumenId,
                                    "IncidenteId": movimientos.IncidenteId,
                                    "TerceriaId": movimientos.TerceriaId,
                                    "FechaMovimiento": FechaEnvio,
                                    "UsuarioQuienPresta" :{"IdUsuario": null},
                                    "UsuarioQuienRecibe" :{"IdUsuario": Genera.IdUsuario},//movimientos.UsuarioQuienRecibe.IdUsuario},
                                    "AreaQuePresta": {"AreaId": areaRecibe},
                                    "AreaQueRecibe": {"AreaId": movimientos.AreaQueRecibe.AreaId},
                                    "SolicitudDocumentoId" : movimientos.SolicitudDocumentoId,
                                    "Observaciones" : "Devolución de Documento de Dirección de Ejecutores, enviado por " + Ejecutor  }
                                    );
                                    EstatusImpresion = true;
                                    usrImpresion =  { "NombreUsuario": Ejecutor, "NombreArea": NombreEjecutores, "Observaciones": ObsParaEnvio};
                                }
                                LlamaApi = true;
                                
                            }
                            else
                            {
                                MovimientosDocumentos.push({
                                "VolumenId": movimientos.VolumenId,
                                "IncidenteId": movimientos.IncidenteId,
                                "TerceriaId": movimientos.TerceriaId,
                                "FechaMovimiento": FechaEnvio,
                                "UsuarioQuienPresta" :{"IdUsuario": movimientos.UsuarioQuienRecibe.IdUsuario},
                                "UsuarioQuienRecibe" :{"IdUsuario": null},
                                "AreaQuePresta": {"AreaId": movimientos.AreaQueRecibe.AreaId},
                                "AreaQueRecibe": {"AreaId": null},
                                "AreaExterna": {"AreaExternaId": area_Externa},
                                "SolicitudDocumentoId" : movimientos.SolicitudDocumentoId,
                                "FechaRecepcion": moment().format('YYYY-MM-DD HH:MM'),
                                "Observaciones" : "Documento Enviado a " + NombreExterno.NombreReceptor + ", de: "+ Nombre_Externo +", Con Observaciones: " + ObsParaEnvio }
                                );
                                MovimientosDocumentos.push({
                                "VolumenId": movimientos.VolumenId,
                                "IncidenteId": movimientos.IncidenteId,
                                "TerceriaId": movimientos.TerceriaId,
                                "FechaMovimiento": FechaEnvio,
                                "UsuarioQuienPresta" :{"IdUsuario": null},
                                "UsuarioQuienRecibe" :{"IdUsuario": Genera.IdUsuario},//movimientos.UsuarioQuienRecibe.IdUsuario},
                                "AreaQuePresta": {"AreaId": null},
                                "AreaQueRecibe": {"AreaId": movimientos.AreaQueRecibe.AreaId},
                                "AreaExterna": {"AreaExternaId": area_Externa},
                                "SolicitudDocumentoId" : movimientos.SolicitudDocumentoId,
                                "Observaciones" : "Recepción de Documento de Área Externa, " + "enviado por " + NombreExterno.NombreReceptor}
                                );
                                LlamaApi = true;
                                EstatusImpresion = true;
                                var datosImpresion = Nombre_Externo + (NombreExterno.Numero!=0 ? (" # " + NombreExterno.Numero) : '');
                                usrImpresion = {"NombreUsuario": NombreExterno.NombreReceptor, "NombreArea": datosImpresion, "Observaciones": NombreExterno.Observaciones};
                                
                            }
                            
                        }
                        else{
                            comun.mensajeDeAlerta("Usuarios Emisor y Receptor no pueden ser iguales.", null, null);
                            LlamaApi = false
                            return;
                        }
                });
                
                if(LlamaApi == true)
                {
                    var datosExternos = this.datosExternos;
                    var peticion = {
                        "TipoMovimiento": mov,
                        MovimientosDocumentos,
                        Volumenes, Incidentes, Tercerias, datosExternos
                    };
                    comun.SeEstaCargandoInformacion(true);
                    axios.post(apiEnvio, peticion, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then( respuesta => {
                    if(respuesta.data.SiHayError)
                        {
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        }
                    else
                        {  
                            
                            if(EstatusImpresion == true)
                            {
                                
                                this.GenerarPrint(this.AreaConsulta, this.usuarioQueGenera, usrImpresion);
                            };
                            if(this.parametros_AreaReceptora.areaId == 21)
                            {
                                
                                this.PrintArchivo(this.AreaConsulta);

                            }  
                            comun.SeEstaCargandoInformacion(false);
                            this.boolRecepcionAutomatica=false;
                            this.CerrarModal(true);
                            
                        }
                        comun.SeEstaCargandoInformacion(false);
                        })
                        .catch(excepcion => {
                            console.log(excepcion);
                            console.log("fallo por parametros");
                            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                            comun.SeEstaCargandoInformacion(false);
                        });
                    }
                }
            }
            // else
            // {
            //     comun.mensajeDeAlerta("Cambie de área diferente al Archivo Judicial." , null, null);
            // }   
        },
        VerificaVolumenes()
        {
            var Contador = 0;
            $.each(this.ListaQueSeVa, function(index, Documentos){
                if(Documentos.Volumen.Fojas == 0){
                    Contador ++ ;
                }
                }
            );
            if(Contador>0)
                {
                    comun.mensajeDeAlerta("Actualice la Fojas en Volumen(es)", null, null);
                    return false;
                };
            return true;
        },
        validaDatos(){
            var envioExterno= this.Externo;
            if(envioExterno == false)
            {
                if(this.parametros_AreaReceptora.areaId== -1)
                {
                    { comun.mensajeDeAlerta("Indicar el área receptora del Documento.", null, null);
                    return false;}
                };
                if(this.parametros_UsuarioReceptor.usuarioId == -1 && this.parametros_AreaReceptora.areaId!=20 && this.parametros_AreaReceptora.areaId!=21)
                {
                   { comun.mensajeDeAlerta("Indicar el Usuario receptor del Documento.", null, null);
                    return false;} 
                };
                if(this.parametros_AreaReceptora.areaId==20)
                {
                    if(this.UsuarioEjecutores == "")
                    {
                        comun.mensajeDeAlerta("Indicar el Usuario de la Dirección de Ejecutores", null, null);
                        return false;
                    };
                    if(this.ObservacionesParaEnvio == "")
                    {
                        comun.mensajeDeAlerta("El envío a esta Dirección debe incluir Observaciones", null, null);
                        return false;
                    }
                }
            }
            else
            {
                if(this.parametros_Externo.areaExternaId == -1)
                {
                    { comun.mensajeDeAlerta("Seleccione un Area Externa.", null, null);
                    return false;} 
                }
                if(this.datosExternos.NombreReceptor == "")
                {
                   { comun.mensajeDeAlerta("Completar el Usuario externo receptor del Documento.", null, null);
                    return false;} 
                };
                // if(this.ObservacionesParaEnvio == "")
                // {
                //    { comun.mensajeDeAlerta("Agregar Observaciones sobre el Envio del Documento.", null, null);
                //     return false;} 
                // };
                
            }
            return true;
        },
        GenerarPrint: function(areaRemite, usrRemite, usrDestino){
            var Listado= this.ListadoParaEnvio;
            let _this= this;
            var Origen = areaRemite.Nombre;
            
            Origen= Origen.toUpperCase();
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet" type="text/css" media="print">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet" type="text/css" media="print">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet" type="text/css" media="print">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('   <div class="area">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-3 align-self-center">');
            printWin.document.write('               <img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/>');
            printWin.document.write('           </div>');
            printWin.document.write('           <div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('               <h5 class="text-center">'+ Origen +'</h5>');
            printWin.document.write('           </div>');
            printWin.document.write('           <div class="form-group col-3"></div>');
            printWin.document.write('       </div>');
            printWin.document.write('   </div>');
            printWin.document.write('   <div class="area">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-12 align-self-center" >');
            printWin.document.write('               <div class="text-center">');
            printWin.document.write('                   <h5 class="text-center">RESGUARDO EXTERNO DE DOCUMENTO</h5>');
            printWin.document.write('               </div>');
            printWin.document.write('           </div>');
            printWin.document.write('       </div>');
            
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-12 text-right">');
            printWin.document.write('               <label>AGUASCALIENTES, AGS., A  '+ moment().format('DD/MM/YYYY') + '</label>');
            printWin.document.write('           </div>');
            printWin.document.write('       </div>');
            //Datos Resguardante
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-4 ">');
            printWin.document.write('               <label><strong>Nombre del Resguardante: </strong></label>');
            printWin.document.write('           </div>');
            printWin.document.write('           <div class="form-group col-8 ">');
            printWin.document.write('               <label>'+ usrDestino.NombreUsuario+'</label>');
            printWin.document.write('           </div>');
            printWin.document.write('       </div>');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-4 ">');
            printWin.document.write('               <label><strong>Área: </strong></label>');
            printWin.document.write('           </div>');
            printWin.document.write('           <div class="form-group col-8 ">');
            printWin.document.write('               <label>'+ usrDestino.NombreArea+'</label>');
            printWin.document.write('           </div>');
            printWin.document.write('       </div>');
            //Observaciones
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-4 ">');
            printWin.document.write('               <label><strong>Observaciones: </strong></label>');
            printWin.document.write('           </div>');
            printWin.document.write('           <div class="form-group col-8 ">');
            printWin.document.write('               <label>'+ usrDestino.Observaciones +'</label>');
            printWin.document.write('           </div>');
            printWin.document.write('       </div>');
            printWin.document.write('   </div>');

            //Tabla con los Documentos
            printWin.document.write('   <div class="area">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-12 ">');
            printWin.document.write('               <label><strong>Contenido del Resguardo</strong></label>');
            printWin.document.write('           </div>');
            printWin.document.write('       </div>');

            printWin.document.write('       <div class="row">');
           
            printWin.document.write('           <div class="form-group col-12">');
            printWin.document.write('               <div class="table-reponsive">');
            printWin.document.write('                   <table class="table table-striped table-light table-hover" style="page-break-before: auto;">');
            printWin.document.write('                       <thead class="thead-dark" style="display:table-header-group"><tr><th>Documento</th><th>Consecutivo</th><th>Juicio</th><th>Partes</th><th>Elemento</th>');
            printWin.document.write('                       </tr></thead>');
            printWin.document.write('                       <tbody class="text-dark">');
            
            
            $.each(Listado, function(index, documentos){
                let descripsion ='';
                if(documentos.Juicio!=null)
                {
                    descripsion = documentos.Juicio.Juicio + ' ' + documentos.Juicio.Tramite;
                }
                printWin.document.write('<tr style="page-break-inside:avoid; page-break-after:auto">');
                printWin.document.write('<td>'+ documentos.TipoDocumento.Nombre +'</td>');
                printWin.document.write('<td>'+ documentos.Consecutivo +'/'+ documentos.Anio +'</td>');
                printWin.document.write('<td>'+ descripsion +'</td>');
                printWin.document.write('<td>'+ _this.DesglosaPartes(documentos.Partes) +'</td>');
                printWin.document.write('<td>'+ _this.DesglosaContenido(documentos.Movimientos) +'</td>');
                printWin.document.write('</tr>');
            });
            
            printWin.document.write('                       </tbody></table>');

            printWin.document.write('               </div>');
            printWin.document.write('           </div>');
            printWin.document.write('        </div>');
            printWin.document.write('   </div>');

            printWin.document.write('   <div class="area" style="page-break-inside:avoid; page-break-after:auto">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-1"></div>');
            printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            printWin.document.write('<br><br><br><br><br>');
            printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            printWin.document.write('           <div class="align-self-center"><label><strong>' + usrRemite.Nombre + ' '+ usrRemite.ApellidoPaterno + ' '+ usrRemite.ApellidoMaterno + '</strong></label><div>');
            printWin.document.write('       </div>');
            printWin.document.write('       <div class="align-self-center">');
            printWin.document.write('           <label><strong>' + usrRemite.AreaAsignado.Nombre + '</strong></label></div>');
            printWin.document.write('       </div>');
            printWin.document.write('</div>');
            printWin.document.write('<div class="form-group col-2"></div>');
            printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            printWin.document.write('<br><br><br><br><br>');
            printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            printWin.document.write('           <div class="align-self-center"><label><strong>' + usrDestino.NombreUsuario + '</strong></label><div>');
            printWin.document.write('       </div>');
            printWin.document.write('       <div class="align-self-center">');
            printWin.document.write('           <label><strong>' + usrDestino.NombreArea + '</strong></label></div>');
            printWin.document.write('       </div>');
            printWin.document.write('</div>');

            printWin.document.write('           <div class="form-group col-1"></div>');
            printWin.document.write('       </div>');
            printWin.document.write('   </div>');

            printWin.document.write('</div>');
            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
        DesglosaContenido: function (datos){
            let Contenido ="";
            if(datos!=null && datos.length>0)
            {
                $.each(datos, function(x, movimientos)
                {
                    if(movimientos.VolumenId!=null)
                    {
                        Contenido = Contenido + "Tomo No: "+ movimientos.Volumen.NumVolumen  + "<br/>";
                    };
                    if(movimientos.IncidenteId!=null)
                    {
                        Contenido = Contenido + "Incidente No: "+ movimientos.Incidente.NumeroIncidente + ",  Tipo: " + movimientos.Incidente.TipoIncidente + "<br/>";
                    };
                    if(movimientos.TerceriaId!=null)
                    {
                        Contenido = Contenido + "Tercería No: "+ movimientos.Terceria.NumeroTerceria + ",  Tipo: " + movimientos.Terceria.TipoTerceria + "<br/>";
                    }

                });
            }
            return Contenido;
        },
        DesglosaPartes: function(partes){
            let Contenido="";
            if(partes!=null && partes.length>0)
            {
                partes.sort((a,b)=>(a.Tipo_Parte>b.Tipo_Parte ? 1:-1));
                Contenido = Contenido + "* ACTOR: <br/>"
                $.each(partes, function(p, lista)
                {
                    if(lista.Tipo_Parte=="ACTOR"){
                        var nombre = lista.Nombre!=null? lista.Nombre: ""; 
                        var ApPaterno = lista.ApellidoPaterno !=null ? lista.ApellidoPaterno : ""
                        var ApMaterno = lista.ApellidoMaterno !=null ? lista.ApellidoMaterno  : "";
                        Contenido = Contenido + nombre + " " + ApPaterno + " "+ ApMaterno + "<br/>";
                    }
                });
                Contenido = Contenido + "* DEMANDADO: <br/>"
                $.each(partes, function(p, lista)
                {
                    if(lista.Tipo_Parte=="DEMANDADO"){
                        var nombre = lista.Nombre!=null? lista.Nombre: ""; 
                        var ApPaterno = lista.ApellidoPaterno !=null ? lista.ApellidoPaterno : ""
                        var ApMaterno = lista.ApellidoMaterno !=null ? lista.ApellidoMaterno  : "";
                        Contenido = Contenido + nombre + " " + ApPaterno + " "+ ApMaterno + "<br/>";
                    }
                })
            }
            return Contenido;
        },
        PrintArchivo(areaRemite){
            var Listado= this.ListadoParaEnvio;
            let _this= this;
            var Origen = areaRemite.Nombre;
            
            Origen= Origen.toUpperCase();
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('   <div class="area">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-3 align-self-center">');
            printWin.document.write('               <img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/>');
            printWin.document.write('           </div>');
            printWin.document.write('           <div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('               <h5 class="text-center">'+ Origen +'</h5>');
            printWin.document.write('           </div>');
            printWin.document.write('           <div class="form-group col-3"></div>');
            printWin.document.write('       </div>');
            printWin.document.write('   </div>');
            printWin.document.write('   <div class="area">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-12 align-self-center" >');
            printWin.document.write('               <div class="text-center">');
            printWin.document.write('                   <h5 class="text-center">ENVIO DE DOCUMENTOS EN PRESTAMO NO REGSITRADOS EN SISTEMA</h5>');
            printWin.document.write('               </div>');
            printWin.document.write('           </div>');
            printWin.document.write('       </div>');
            
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-12 text-right">');
            printWin.document.write('               <label>AGUASCALIENTES, AGS., A  '+ moment().format('DD/MM/YYYY') + '</label>');
            printWin.document.write('           </div>');
            printWin.document.write('       </div>');
            //Datos Resguardante
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-4 ">');
            printWin.document.write('               <label><strong>Área: </strong></label>');
            printWin.document.write('           </div>');
            printWin.document.write('           <div class="form-group col-8 ">');
            printWin.document.write('               <label>Dirección del Archivo Judicial</label>');
            printWin.document.write('           </div>');
            printWin.document.write('       </div>');
            //Observaciones
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-4 ">');
            printWin.document.write('               <label><strong>Observaciones: </strong></label>');
            printWin.document.write('           </div>');
            printWin.document.write('           <div class="form-group col-8 ">');
            printWin.document.write('               <label>Devolución de Documentos en prestamo modalidad anterior</label>');
            printWin.document.write('           </div>');
            printWin.document.write('       </div>');
            printWin.document.write('   </div>');

            //Tabla con los Documentos
            printWin.document.write('   <div class="area">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-12 ">');
            printWin.document.write('               <label><strong>Listado de Documentos</strong></label>');
            printWin.document.write('           </div>');
            printWin.document.write('       </div>');

            printWin.document.write('       <div class="row">');
           
            printWin.document.write('           <div class="form-group col-12">');
            printWin.document.write('               <div class="table-reponsive">');
            printWin.document.write('                   <table class="table table-striped table-light table-hover" style="page-break-before: auto;">');
            printWin.document.write('                       <thead class="thead-dark" style="display:table-header-group"><tr><th>Documento</th><th>Consecutivo</th><th>Juicio</th><th>Partes</th><th>Elemento</th>');
            printWin.document.write('                       </tr></thead>');
            printWin.document.write('                       <tbody class="text-dark">');
            
            
            $.each(Listado, function(index, documentos){
                printWin.document.write('<tr style="page-break-inside:avoid; page-break-after:auto">');
                printWin.document.write('<td>'+ documentos.TipoDocumento.Nombre +'</td>');
                printWin.document.write('<td>'+ documentos.Consecutivo +'/'+ documentos.Anio +'</td>');
                printWin.document.write('<td>'+ documentos.Juicio.Juicio +', '+ documentos.Juicio.Tramite +'</td>');
                printWin.document.write('<td>'+ _this.DesglosaPartes(documentos.Partes) +'</td>');
                printWin.document.write('<td>'+ _this.DesglosaContenido(documentos.Movimientos) +'</td>');
                printWin.document.write('</tr>');
            });
            
            printWin.document.write('                       </tbody></table>');

            printWin.document.write('               </div>');
            printWin.document.write('           </div>');
            printWin.document.write('        </div>');
            printWin.document.write('   </div>');

            printWin.document.write('   <div class="area" style="page-break-inside:avoid; page-break-after:auto">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-1"></div>');
            printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            printWin.document.write('<br><br><br><br><br>');
            printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            printWin.document.write('           <div class="align-self-center"><label><strong>Nombre Completo</strong></label><div>');
            printWin.document.write('       </div>');
            printWin.document.write('       <div class="align-self-center">');
            printWin.document.write('           <label><strong>' + Origen + '</strong></label></div>');
            printWin.document.write('       </div>');
            printWin.document.write('</div>');
            printWin.document.write('<div class="form-group col-2"></div>');
            printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            printWin.document.write('<br><br><br><br><br>');
            printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            printWin.document.write('           <div class="align-self-center"><label><strong>Nombre Completo</strong></label><div>');
            printWin.document.write('       </div>');
            printWin.document.write('       <div class="align-self-center">');
            printWin.document.write('           <label><strong>ARCHIVO JUDICIAL</strong></label></div>');
            printWin.document.write('       </div>');
            printWin.document.write('</div>');

            printWin.document.write('           <div class="form-group col-1"></div>');
            printWin.document.write('       </div>');
            printWin.document.write('   </div>');

            printWin.document.write('</div>');
            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        }
    },
    mounted(){
        
        this.datosDelJuicio = this.JuicioDatos;
        this.usuarioQueGenera = this.usrArea;
        //console.log(this.usrArea);
        this.AreaConsulta = this.usrArea.AreaAsignado;
        this.boolRecepcionAutomatica= false;
        var countSolicitudes = 0;
        var Out_Area = 0;
        this.fechaParaRecepcion = moment().format('YYYY-MM-DD') + ' ' + moment().format('HH:MM');
        var areaTemp= this.AreaConsulta.AreaId;
        var listadoMovimientos =[];
        $.each(this.ListadoParaEnvio, function(index, documento){
            $.each(documento.Movimientos, function(i, movimientos)
            {
                listadoMovimientos.push(movimientos);
                // if(movimientos.VolumenId!=null && movimientos.Volumen.Amparos!=null && movimientos.Volumen.Amparos.length>0)
                // {
                //     $.each(movimientos.Volumen.Amparos, function(id, amparo){
                //         listadoMovimientos.push(amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen)
                //     });
                // }
            });
            
        });
        this.ListaQueSeVa = listadoMovimientos;
        $.each(this.ListadoParaEnvio, function(index, area){
            
            if(area.VolumenId!=null)
            {
                if(area.Volumen.Area.AreaId != areaTemp)
                {
                    Out_Area += 1;
                }
            };
            if(area.IncidenteId!=null)
            {
                if(area.Incidente.Inventario.Area.AreaId != areaTemp)
                {
                    Out_Area += 1;
                }
            };
            if(area.TerceriaId!=null)
            {
                if(area.Terceria.Inventario.Area.AreaId != areaTemp)
                {
                    Out_Area += 1;
                }
            };
            if(area.SolicitudDocumentoId != null)
            {
              countSolicitudes+=1;
            }
        });  
        this.countSolicitudes = countSolicitudes;
                
        //this.ListaQueSeVa = this.ListadoParaEnvio;
        this.parametros_AreaReceptora.areaId = this.AreaConsulta.AreaId
        this.conSolicitudes = countSolicitudes;
        this.fueraArea = Out_Area;
        this.Mostrar();
        
    }
}

</script>
<style scoped>
    input[type="text"]:read-only {
        background: #f3f3f3;
    }

    input[type="text"]:read-only:focus {
        color: #7e7f74;
    }
    .modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1050;
        display: none; 
        overflow: hidden;
        outline: 0;
        
    }
    .modal-content {
        background-color:  #7e7f74;
    }
    .modal-header {
        background-color:  #007573;
    }
    .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>




// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/DatosEnvio.vue